import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {

  },
  mutations: {

  },
  actions: {
    async fetchHelp({ commit, state }, id) {

      commit('RESET_STATE');

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/help/'+id+'/');
        commit('SET_DATA', {data:response.data.data});
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    help: state => state.data,
    helpLoading: state => state.loading,
    helpError: state => state.error,
    helpLoaded: state => state.loaded,
  }
})